import { Button, Flex, Heading, useBoolean } from '@chakra-ui/react'
import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { ConceptsList } from '../../containers/concepts'
import { ConceptsCarSearch } from '../../containers/search/carkulka/ConceptsCarSearch'
import { PageToolbar } from '../../containers/PageToolbar'
import { SearchButton } from '../../containers/search/SearchButton'
import { PageContent } from '../../containers/PageContent'
import { useGetAll } from '../../hooks/useInsuranceParams'
import { createContext, useEffect, useState } from 'react'
import { InsuranceParamsVehiclePagedQuery } from 'BrokerTsLib/src/dtos'
import { Select } from '../../icons'
import { WithAuth } from '../../containers/hoc/WithAuth'
import { IPaginationContext } from 'BrokerTsLib/src/context'

export const conceptsCarsContext = createContext<IPaginationContext<InsuranceParamsVehiclePagedQuery>>({} as IPaginationContext<InsuranceParamsVehiclePagedQuery>)

const _ConceptsCarPage = () => {
  const [isOpen, setOpen] = useBoolean(false)
  const [allowSelect, setAllowSelect] = useBoolean(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [deletedCounter, setDeletedCounter] = useState(0);
  const [filter, setFilter] = useState<InsuranceParamsVehiclePagedQuery>({
    //dateCreatedFrom: defaultDateFrom,
    listType: 1,
    pageIndex: 1,
  });

  const { data, mutateAsync: getAllAsync, isLoading: isLoading } = useGetAll()
  const items = data?.data

  const reloadData = () => setDeletedCounter(deletedCounter + 1)

  useEffect(() => {
    setFilter({ ...filter, pageSize: pageSize, pageIndex: currentPage })
  }, [pageSize, currentPage]);

  useEffect(() => {
    if (filter.pageSize) // nechci spoustet nacitani na pageload 2x
      getAllAsync(filter)
  }, [filter, deletedCounter]);

  return (
    <Section>
      <Container>
        <PageContent>
          <conceptsCarsContext.Provider value={
            {
              loading: isLoading,
              totalCount: items?.totalCount ?? 0,
              currentPage: currentPage,
              pageSize: pageSize,
              filter: filter,
              setCurrentPage: setCurrentPage,
              setPageSize: setPageSize,
              updateFilter: f => setFilter({ ...f }),
              reload: reloadData
            }
          }>
            <PageToolbar
              leftElements={
                <Flex sx={{ gap: 4, alignItems: 'center' }}>
                  <Heading as="h1">Rozpracované nabídky</Heading>
                </Flex>
              }
              rightElements={
                <Flex sx={{ gap: 4 }}>
                  <Button variant="ghost" onClick={setAllowSelect.toggle}>
                    <Select color="secondary.500" />
                    {allowSelect ? 'Zrušit smazání' : 'Vybrat ke smazání'}
                  </Button>
                  <SearchButton isOpen={isOpen} setOpen={setOpen} />
                </Flex>
              }
            />

            {isOpen && <ConceptsCarSearch />}

            <ConceptsList concepts={items?.items ?? []} withPaginator allowSelect={allowSelect} />
          </conceptsCarsContext.Provider>
        </PageContent>
      </Container>
    </Section>
  )
}

export const ConceptsCarPage = WithAuth(_ConceptsCarPage)